import classNames from "classnames";

import { ignoreAttribute } from "@ascendnow/shared";

import styles from "./AscFindTheWordsPuzzleCell.module.scss";

export interface AscFindTheWordsPuzzleCellProps {
  className?: string;
  character?: string;
  readonly?: boolean;
  highlighted?: boolean;
  selected?: boolean;
  id: number;
  onSelect?: (id: number) => void;
  onHover?: (id: number) => void;
  colors?: string[];
}

export default function AscFindTheWordsPuzzleCell({
  className,
  character,
  readonly,
  onSelect,
  onHover,
  highlighted,
  selected,
  id,
  colors = [],
}: AscFindTheWordsPuzzleCellProps) {
  function handleOnClick() {
    if (readonly) {
      return;
    }
    onSelect?.(id);
  }
  function handleOnHover() {
    if (readonly) {
      return;
    }
    onHover?.(id);
  }

  return (
    <div
      data-testid={`asc-find-the-words-puzzle-cell-${id}`}
      className={classNames(
        styles.ground,
        {
          [styles.highlighted]: highlighted,
          [styles.selected]: selected,
          [styles.readonly]: readonly,
        },
        className
      )}
      onClick={handleOnClick}
      onMouseOver={handleOnHover}
      {...ignoreAttribute.contrast}
    >
      <span className={styles.character} {...ignoreAttribute.contrast}>
        {character}
      </span>
      {highlighted
        ? colors?.map((color, index) => (
            <div
              key={index}
              className={styles.highlightColor}
              style={{
                background: color,
              }}
              {...ignoreAttribute.contrast}
            />
          ))
        : null}
    </div>
  );
}
